// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2VixhnpMx{display:block;height:0;width:0}\n", ""]);
// Exports
exports.locals = {
	"sentinel": "_2VixhnpMx"
};
module.exports = exports;
